import angular from 'angular';
import uiRouter from 'angular-ui-router';
import bankTxComponent from './banktx.component';

let bankTxModule = angular.module('bankTx', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newBankTx', {
            url: '/bankTxes/new',
            component: 'bankTx',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editBankTx', {
            url: '/bankTxes/:id',
            component: 'bankTx',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                bankTx: (BankTxesService, $stateParams) => {
                    return BankTxesService.findById($stateParams.id, {
                        include: ['client', {
                            relation: 'paymentItem',
                            scope: {
                                include: {
                                    relation: 'receipt',
                                    scope: {
                                        include: 'employee'
                                    }
                                }
                            }
                        }]
                    });
                }
            }
        });
})
.component('bankTx', bankTxComponent)
.name;

export default bankTxModule;
